/* global ThemeSettings, _hashed_password */

window.fbAsyncInit = () => {
  FB.init({
    appId: '',
    cookie: true,
    xfbml: true,
    version: 'v16.0',
  });
};

function getFbUserData(token) {
  FB.api('/me', { locale: 'en_CA', fields: 'id,first_name,last_name,email' },
    (response) => {
      const userData = {
        id: response.id,
        first_name: response.first_name,
        last_name: response.last_name,
        email: response.email,
        token,
        from: 'facebook',
      };

      saveUserData(userData);
    });
}

const setStatusMsgVisibility = (isVisible, message) => {
  const statusMsg = document.querySelector('.status-message--success');

  if (!statusMsg) throw new Error('Please add .status-message--success container');

  statusMsg.innerHTML = isVisible ? message : '';
  statusMsg.style.display = isVisible ? 'block' : 'none';
};

const focusFirstInccorrectField = (form) => {
  const errorMessage = form.querySelector('.error-message');

  if (!errorMessage) return;

  const wrongField = errorMessage.parentNode.querySelector('input:not([type="hidden"])');

  wrongField.focus();
};

function saveUserData(userData) {
  let targetUrl = window.location.href;
  Loader?.setLoaderVisibility(true);

  if (targetUrl.includes('account/login')) {
    const redirectUrlParameter = getParameterByName('return_url');
    const regexExpression = new RegExp(/[{}()<>"'$%!@#^*+'";:,.|~`]/g);
    const regexValidate = regexExpression.test(redirectUrlParameter);

    if (!regexValidate && redirectUrlParameter) {
      const redirectUrl = redirectUrlParameter.substring(1);

      targetUrl = `https://enfamil-canada.myshopify.com/${redirectUrl}`;
    } else {
      targetUrl = 'https://enfamil-canada.myshopify.com/cart';
    }
  }

  const url = `${ThemeSettings.sourceApi}enfa-cdp-api/v1/enfa-user-app/shop-token`;
  const authData = {};

  authData.data = `${ThemeSettings.token}`;

  const myHeaders = new Headers();

  myHeaders.append('Content-Type', 'application/json');
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(authData),
    headers: myHeaders,
  }).then((result) => result.json())
    .then((response) => {
      const bodyData = {
        email: userData.email,
        social_vendor: userData.from,
        input_token: userData.token,
        fb_user_id: userData.id,
        source: 'WEB',
        target_url: targetUrl,
      };

      const requestBody = {};

      requestBody.data = _hashed_password(JSON.stringify(bodyData));
      requestBody.source = 'WEB';

      setCookie('_uat', response.access_token, 10);

      myHeaders.append('Authorization', `Bearer ${response.access_token}`);

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(requestBody),
        redirect: 'follow',
      };

      fetch(`${ThemeSettings.sourceApi}enfa-cdp-api/v1/enfa-user-app/shop-social-login`, requestOptions)
        .then((responseData) => responseData.json())
        .then((result) => {
          const formData = {
            birthDate: '',
            email: userData.email,
            firstName: userData.first_name,
            lastName: userData.last_name,
          };

          if (result.status_code === 200) {
            if (typeof result.data.oauth_details !== 'undefined') {
              const cookieData = result.data.oauth_details;

              setCookie('_uat', cookieData.access_token, 10);
              setCookie('_eu_bstg', result.data.stage, 10);
              setCookie('enfa_user_iid', result.data.user_id, 10);
              setCookie('eco-coupon', result.data.eco_coupon, 10);
              setCookie('smrq', result.data.sample_requested);

              if (result.data._enfagrow_contest) setCookie('_enfagrow_contest', result.data._enfagrow_contest);
              if (result.data.Premium_eligible) setCookie('_bstg', result.data.Premium_eligible, 10);
              
              if (result.data.Basic_eligible) {
                setCookie('_bs03', result.data.Basic_eligible, 10);
              } else {
                setCookie('_bs3plus', result.data.Basic_eligible, 10);
              }

              if(result.data.sms_optin) setCookie('_smsoptin', result.data.sms_optin, 10);
              if(result.data.email_optin) setCookie('_emailoptin', result.data.email_optin, 10);

              Loader?.setLoaderVisibility(false);
              window.location = result.data.multipass;
            } else {
              const regForm = document.querySelector('#signup-form');

              if (regForm !== null) {
                const firstName = regForm.querySelector('#AddressFirstNameNew');
                const lastName = regForm.querySelector('#AddressLastNameNew');
                const emailAddr = regForm.querySelector('#email_address');
                const birthDate = regForm.querySelector('#dob');

                firstName.value = formData.firstName;
                lastName.value = formData.lastName;
                emailAddr.value = formData.email;
                birthDate.value = formData.birthDate;

                setStatusMsgVisibility(true, I18n['validation_msg.fill_form']);
                focusFirstInccorrectField(regForm);
                Loader?.setLoaderVisibility(false);
              } else {
                const encryptedData = btoa(JSON.stringify(formData));

                if (encryptedData) {
                  const redirectUrl = Shopify.locale !== 'en' ? `/${Shopify.locale}/account/register?short_form_data=${encryptedData}` : `/account/register?short_form_data=${encryptedData}`;

                  window.location.href = redirectUrl;
                }
              }
            }
          } else if (result.status_code === 400) {
            const encryptedData = btoa(JSON.stringify(formData));

            if (encryptedData) {
              const redirectUrl = Shopify.locale !== 'en' ? `/${Shopify.locale}/account/register?short_form_data=${encryptedData}` : `/account/register?short_form_data=${encryptedData}`;

              window.location.href = redirectUrl;
            }
          }
        })
        .catch((error) => { 
          Loader?.setLoaderVisibility(true);
          throw new Error(error);
        });

      return response;
    });
}

const b64DecodeUnicode = (str) => decodeURIComponent(
  Array.prototype.map.call(atob(str), (c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''),
);

const parseJwt = (token) => JSON.parse(
  b64DecodeUnicode(
    token.split('.')[1].replace('-', '+').replace('_', '/'),
  ),
);

const handleCredentialResponse = (response) => {
  const data = parseJwt(response.credential);
  const userData = {
    id: data.sub,
    first_name: data.given_name,
    last_name: data.family_name,
    email: data.email,
    token: response.credential,
    from: 'google',
  };

  saveUserData(userData);
};

const googleAppId = '543795203219-21vbuhfji082g3lccejodtl7da22dl88.apps.googleusercontent.com';
const startApp = function() {
  if (typeof google !== 'undefined') {
    google.accounts.id.initialize({client_id: googleAppId, callback: handleCredentialResponse});

    google.accounts.id.renderButton(document.getElementById('google-button'), {
      theme: 'outline',
      size: 'large',
      shape: 'circle',
      type: 'icon',
      width: 240,
      height: 50,
    });
    google.accounts.id.prompt();
  }
};

startApp();

const socialErrors = () => {
  const socialError = document.querySelectorAll('.social-error-message');

  if (!navigator.cookieEnabled && socialError) {
    const socialErrorsArray = Array.from(socialError);

    socialErrorsArray.forEach((element) => {
      element.innerHTML = I18n['validation_msg.cookie_msg'];
    });
  }
};

const connectFb = () => {
  if (typeof FB !== 'undefined') {
    FB.login((response) => {
      if (response.authResponse) {
        const { accessToken } = response.authResponse;

        getFbUserData(accessToken);
      }
    }, { scope: 'email' });
  } else {
    socialErrors();
  }
};

document.querySelector('.social-button_fb')?.addEventListener('click', connectFb);
document.querySelector('.social-button_google')?.addEventListener('click', startApp);
